export default "__VITE_ASSET__Bk35zfSt__"